module.exports = __webpack_public_path__ + "img/service-213.e767aa9a.png";